import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import FGMaterialConfig from "./FGMaterialConfig";
import { setActiveDataElement } from "../../../redux/userSlice";

function FGCustomConfiguration() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("FG Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="FG Inventory Custom Configuration"
            />
            <div class="container">
                <FGMaterialConfig />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
export default FGCustomConfiguration
